import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import * as actions from "./actiontypes";
import { SNCRuleListModel } from "./models";
import { SNCRulesApi } from "./sncRulesApi";

export type SNCRulesAction =
      ({ type: typeof actions.LOAD_SNCRULES_SUCCESS } & Payload<SNCRuleListModel[]>)

export const loadSncRulesSuccess = (payload: SNCRuleListModel[]): SNCRulesAction => ({
    payload,
    type: actions.LOAD_SNCRULES_SUCCESS
});

export function loadSncRules() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadSncRules", SNCRulesApi.getAll());
        dispatch(loadSncRulesSuccess(result));
    };
}
